module.exports = __webpack_public_path__ + "img/188.cc0ddf94.jpg";